import { useCallback, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { api } from "services/api.service";
import { useAlert } from "./useAlert";

export default function useEarnings() {
  const params = useParams();
  const [isLoading, setLoading] = useState(false);
  const [earnings, setEarnings] = useState<number | null>(null);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [transactionGroups, setTransactionGroups] = useState<any>();
  const [totalPages, setTotalPages] = useState<number>(0);
  const [count, setCount] = useState<number>(0);
  const { search } = useLocation();
  const { alertError, alertSuccess } = useAlert();

  const getEarnings = useCallback(() => {
    setLoading(true);
    api.get(`/organizations/${params.uuid}/transaction_groups${search}`).then(
      ({
        data: {
          earningsBalance,
          transactionGroups: fetchedTransactionGroups,
          meta: { totalPages: fetchedTotalPages, count: fetchedCount },
        },
      }) => {
        setEarnings(earningsBalance);
        setTransactionGroups(fetchedTransactionGroups);
        setTotalPages(fetchedTotalPages);
        setCount(fetchedCount);
      },
    );
  }, [params.uuid, search]);

  const deleteTransactionGroup = useCallback(
    (transactionGroupId: string) => {
      api
        .delete(`/organizations/${params.uuid}/transaction_groups/${transactionGroupId}`)
        .then(() => {
          getEarnings();
          alertSuccess("Transaction group deleted successfully");
        })
        .catch((error) => {
          alertError(error.response.data.message);
        });
    },
    [params.uuid, getEarnings, alertSuccess, alertError],
  );

  useEffect(() => {
    getEarnings();
  }, [getEarnings, search]);

  return {
    earnings,
    transactionGroups,
    totalPages,
    count,
    isLoading,
    deleteTransactionGroup,
  };
}
